function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Button, Space, Divider, Drawer, Table, message, Modal, Tabs, notification } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import AddServiceProvider from '../components/forms/AddServiceProvider';
import Common from '../components/includes/Common';
import EditServiceProvider from '../components/forms/EditServiceProvider';
import { PencilFill, HourglassSplit, TruckFrontFill, ArrowLeftSquareFill, CartPlusFill, CartCheckFill, ArrowRightSquareFill, Bank2, Cash, Receipt } from 'react-bootstrap-icons';
import AddProviderPayment from '../components/forms/AddProviderPayment';
import moment from 'moment';
import AccountantCashTransactionHistory from '../components/AccountantCashTransactionHistory';
import InitiateCashIn from '../components/forms/InitiateCashIn';
import InitiateCashout from '../components/forms/InitiateCashout';
import AddBankTransaction from '../components/forms/AddBankTransaction';
import InvoiceList from '../components/InvoiceList';
import AddPurchaseOrder from '../components/forms/AddPurchaseOrder';
import PurchaseOrdersList from '../components/PurchaseOrdersList';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Accountant = function Accountant() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAddSpVisible = _useState2[0],
    setIsAddSpVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isEditSpVisible = _useState4[0],
    setIsEditSpVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSpPaymentVisible = _useState6[0],
    setIsSpPaymentVisible = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    providersArrayData = _useState8[0],
    setProvidersArrayData = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    transactionList = _useState0[0],
    setTransactionList = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isDataLoading = _useState10[0],
    setIsDataLoading = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDataChanged = _useState12[0],
    setIsDataChanged = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedSp = _useState14[0],
    setSelectedSp = _useState14[1];
  var _useState15 = useState(moment().startOf('month').format()),
    _useState16 = _slicedToArray(_useState15, 2),
    from = _useState16[0],
    setFrom = _useState16[1];
  var _useState17 = useState(moment().endOf('month').format()),
    _useState18 = _slicedToArray(_useState17, 2),
    to = _useState18[0],
    setTo = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isNewTransactionOpen = _useState20[0],
    setIsNewTransactionOpen = _useState20[1];
  var _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    operationType = _useState22[0],
    setOperationType = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    myInVoices = _useState24[0],
    setMyInvoices = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showNewPo = _useState26[0],
    setShowNewPo = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    poList = _useState28[0],
    setPoList = _useState28[1];
  var _useState29 = useState(moment().startOf("month").format()),
    _useState30 = _slicedToArray(_useState29, 2),
    poFrom = _useState30[0],
    setPoFrom = _useState30[1];
  var _useState31 = useState(moment().endOf("month").format()),
    _useState32 = _slicedToArray(_useState31, 2),
    poTo = _useState32[0],
    setPoTo = _useState32[1];
  var providersCol = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "DESIGNATION"
    }),
    dataIndex: 'label',
    key: 'label',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "CONTACT"
    }),
    dataIndex: 'contact',
    key: 'contact',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "TELEPHONE"
    }),
    dataIndex: 'mobile',
    key: 'mobile',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {}),
    dataIndex: 'provider',
    key: 'provider',
    render: function render(p) {
      return /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            handleProviderEdition(p);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(PencilFill, {
              size: 20
            })
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            setSelectedSp(p);
            setShowNewPo(true);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "BON DE COMMANDE"
          })
        })]
      });
    }
  }];
  var tabsContent = [{
    key: 1,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(HourglassSplit, {
        size: 25
      }), " HISTORIQUE OPERATIONS"]
    }),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("h5", {
        children: /*#__PURE__*/_jsx("b", {
          children: "HISTORIQUE TRANSACTIONS"
        })
      }), /*#__PURE__*/_jsx(AccountantCashTransactionHistory, {
        reloadData: function reloadData() {
          setIsDataChanged(true);
        },
        refresh: isDataChanged
      })]
    })
  }, {
    key: 2,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(TruckFrontFill, {
        size: 25
      }), " LISTE FOURNISSEURS"]
    }),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("h5", {
        children: /*#__PURE__*/_jsx("b", {
          children: "LISTE FOURNISSEURS"
        })
      }), /*#__PURE__*/_jsx(Table, {
        size: "small",
        bordered: true,
        columns: providersCol,
        dataSource: providersArrayData,
        loading: isDataLoading
      }), " ,"]
    })
  }, {
    key: 4,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CartCheckFill, {
        size: 25
      }), "BONS DE COMMANDE"]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(PurchaseOrdersList, {
        list: poList,
        refresh: function refresh() {
          setIsDataChanged(true);
        }
      })
    })
  }, {
    key: 3,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(Receipt, {
        size: 25
      }), " FACTURES"]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(InvoiceList, {
        list: myInVoices,
        refresh: isDataLoading,
        reload: function reload() {
          setIsDataChanged(true);
        },
        origin: "accountant"
      })
    })
  }];
  var handleProviderEdition = function handleProviderEdition(p) {
    setSelectedSp(p);
    setIsEditSpVisible(true);
  };
  useEffect(function () {
    setIsDataChanged(false);
    axios.all([axios.get("".concat(Common.baseApiUrl, "getserviceproviders/").concat(Common.currentUser.id)), axios.get("".concat(Common.baseApiUrl, "getvalidatedinvoices/").concat(Common.currentUser.id)), axios.get("".concat(Common.baseApiUrl, "getpos/").concat(from, "/").concat(to, "/").concat(Common.currentUser.id))]).then(function (response) {
      if (response[0].data.status == 200) {
        setProvidersArrayData([]);
        response[0].data.providers.forEach(function (p) {
          setProvidersArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: p.id,
              label: p.label,
              contact: p.contact_name,
              mobile: p.contact_mobile,
              provider: p
            }]);
          });
        });
      } else {
        message.error({
          content: response[0].data.message,
          delay: 4
        });
      }
      if (response[1].data.status == 200) {
        setMyInvoices([]);
        setMyInvoices(response[1].data.invoices);
      } else {
        setLoadError(response[1].data.message);
      }
      if (response[2].data.status == 200) {
        setPoList(response[2].data.pos);
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue '.error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        wrap: true,
        children: [/*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            setIsSpPaymentVisible(true);
          },
          children: /*#__PURE__*/_jsxs("b", {
            children: [/*#__PURE__*/_jsx(Cash, {
              size: 20
            }), " PAIEMENT FOURNISSEUR"]
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            setIsAddSpVisible(true);
          },
          children: /*#__PURE__*/_jsxs("b", {
            children: [/*#__PURE__*/_jsx(CartPlusFill, {
              size: 20
            }), " AJOUT FOURNISSEUR"]
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            setOperationType(0);
            setIsNewTransactionOpen(true);
          },
          children: /*#__PURE__*/_jsxs("b", {
            children: [/*#__PURE__*/_jsx(ArrowLeftSquareFill, {
              size: 20
            }), " INIT. SORTIE"]
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            setOperationType(1);
            setIsNewTransactionOpen(true);
          },
          children: /*#__PURE__*/_jsxs("b", {
            children: [/*#__PURE__*/_jsx(ArrowRightSquareFill, {
              size: 20
            }), " APPRO CAISSE"]
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            setOperationType(2);
            setIsNewTransactionOpen(true);
          },
          children: /*#__PURE__*/_jsxs("b", {
            children: [/*#__PURE__*/_jsx(Bank2, {
              size: 20
            }), " DEPOT BANQUE"]
          })
        })]
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Tabs, {
            items: tabsContent,
            animated: true
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: "FAIRE UN PAIEMENT FOURNISSEUR"
      }),
      width: "450px",
      footer: null,
      destroyOnClose: true,
      open: isSpPaymentVisible,
      onCancel: function onCancel() {
        setIsSpPaymentVisible(false);
      },
      children: /*#__PURE__*/_jsx(AddProviderPayment, {
        handler: function handler() {
          setIsDataChanged(true);
          setIsSpPaymentVisible(false);
          message.success({
            content: 'Opération réussie',
            delay: 4
          });
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "AJOUTER FOURNISSEUR"
      }),
      width: "300px",
      destroyOnClose: true,
      open: isAddSpVisible,
      onClose: function onClose() {
        return setIsAddSpVisible(false);
      },
      children: /*#__PURE__*/_jsx(AddServiceProvider, {
        handler: function handler() {
          setIsDataChanged(true);
          setIsAddSpVisible(false);
          message.success({
            content: 'Opération réussie',
            delay: 4
          });
        }
      })
    }), selectedSp != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "MODIFIER LE FOURNISSEUR"
        }),
        width: "300px",
        destroyOnClose: true,
        open: isEditSpVisible,
        onClose: function onClose() {
          return setIsEditSpVisible(false);
        },
        children: /*#__PURE__*/_jsx(EditServiceProvider, {
          provider: selectedSp,
          handler: function handler() {
            setIsDataChanged(true);
            setIsEditSpVisible(false);
            message.success({
              content: 'Opération réussie',
              delay: 4
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        centered: true,
        title: /*#__PURE__*/_jsx("b", {
          children: "NOUVEAU BON DE COMMANDE"
        }),
        width: "750px",
        destroyOnClose: true,
        open: showNewPo,
        footer: null,
        onCancel: function onCancel() {
          return setShowNewPo(false);
        },
        children: /*#__PURE__*/_jsx(AddPurchaseOrder, {
          provider: selectedSp,
          handler: function handler() {
            setIsDataChanged(true);
            setShowNewPo(false);
            message.success({
              content: 'Opération réussie',
              delay: 4
            });
          }
        })
      })]
    }), operationType != null && /*#__PURE__*/_jsxs(Modal, {
      open: isNewTransactionOpen,
      onCancel: function onCancel() {
        setIsNewTransactionOpen(false);
      },
      title: /*#__PURE__*/_jsxs("b", {
        children: [operationType == 0 && "SORTIE DE CAISSE", " ", operationType == 1 && "ENTREE DE CAISSE", " ", operationType == 2 && "DEPOT BANQUE"]
      }),
      footer: null,
      children: [operationType == 0 && /*#__PURE__*/_jsx(InitiateCashout, {
        operationType: operationType,
        handler: function handler() {
          setIsDataChanged(true);
          setIsNewTransactionOpen(false);
          notification.success({
            message: 'Transaction enregistrée !'
          });
        }
      }), operationType == 1 && /*#__PURE__*/_jsx(InitiateCashIn, {
        operationType: operationType,
        handler: function handler() {
          setIsDataChanged(true);
          setIsNewTransactionOpen(false);
          notification.success({
            message: 'Transaction enregistrée !'
          });
        }
      }), operationType == 2 && /*#__PURE__*/_jsx(AddBankTransaction, {
        operationType: operationType,
        handler: function handler() {
          setIsDataChanged(true);
          setIsNewTransactionOpen(false);
          notification.success({
            message: 'Transaction enregistrée !'
          });
        }
      })]
    })]
  });
};
export default Accountant;